import { BadgeCheck } from "lucide-react";

/**
 * Small "Verified ✓" badge. Renders nothing if verified=false.
 */
export default function VerifiedBadge({ verified, size = "sm", className = "", testId }) {
  if (!verified) return null;
  const cls = size === "lg"
    ? "text-xs px-2 py-1"
    : "text-[10px] px-1.5 py-0.5";
  return (
    <span
      data-testid={testId}
      title="Verified — proof of insurance on file"
      className={`inline-flex items-center gap-1 bg-forest text-white overline ${cls} ${className}`}
    >
      <BadgeCheck className={size === "lg" ? "w-3.5 h-3.5" : "w-3 h-3"} /> Verified
    </span>
  );
}
